module.exports = __webpack_public_path__ + "img/cleanHand4.3230e208.jpg";